<template>
  <div class="form__field">
<!--    <div class="form__field__group">-->
      <a
        class="button button--bordered"
        v-bind:class="{ 'button--primary': !isPrevButton, 'button--primary-light': isPrevButton }"
        @click="e => $emit('click', e)"
      >
        <span v-if="isPrevButton && !withoutIcon" class="button__icon icon-left-open-big"></span>
        <span class="button__label">{{ label }}</span>
        <span v-if="!isPrevButton && !withoutIcon" class="button__icon icon-right-open-big"></span>
      </a>
<!--    </div>-->
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    withoutIcon: Boolean,
    isPrevButton: Boolean
  }
};
</script>
